import { ROAD_BASE_URL } from "../utils/urls";

const deleteDataRoad = async (uri: any) => {
  const response = await fetch(`${ROAD_BASE_URL}/${uri}`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
  const result = await response.json();
  return result;
};

export default deleteDataRoad;
